module.exports = __webpack_public_path__ + "img/avatar-9.bae8e081.jpg";